module.exports = __webpack_public_path__ + "img/empty_product.d08c213a.svg";